import React, { useState } from "react";
import {
    DataGridPremium,
    GridToolbarContainer,
    GridToolbarExport,
    useGridApiRef,
} from "@mui/x-data-grid-premium";
import { styled } from "@mui/material/styles";
import { Typography, Button } from "@mui/material";
import { LicenseInfo } from "@mui/x-license";
import AddIcon from '@mui/icons-material/Add';

const StyledDataGridPremium = styled(DataGridPremium)(({ theme }) => ({
    // [`& .${gridClasses.row}.even`]: {
    //     backgroundColor: theme.palette.grey[200],
    //     '&:hover': {
    //         backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
    //         '@media (hover: none)': {
    //             backgroundColor: 'transparent',
    //         },
    //     },
    //     '&.Mui-selected': {
    //         backgroundColor: alpha(
    //             theme.palette.primary.main,
    //             ODD_OPACITY + theme.palette.action.selectedOpacity,
    //         ),
    //         '&:hover': {
    //             backgroundColor: alpha(
    //                 theme.palette.primary.main,
    //                 ODD_OPACITY +
    //                 theme.palette.action.selectedOpacity +
    //                 theme.palette.action.hoverOpacity,
    //             ),
    //             '@media (hover: none)': {
    //                 backgroundColor: alpha(
    //                     theme.palette.primary.main,
    //                     ODD_OPACITY + theme.palette.action.selectedOpacity,
    //                 ),
    //             },
    //         },
    //     },
    //     ...theme.applyStyles('dark', {
    //         backgroundColor: theme.palette.grey[800],
    //     }),
    // },
    '& .MuiDataGrid-iconButtonContainer': {
        visibility: 'visible',
        width: 'auto',
    },
    '& .MuiDataGrid-sortIcon': {
        opacity: 'inherit !important',
    },
    "& .MuiDataGrid-cell": {
        paddingTop: "5px !important",
    },
    "& .highlighted-row": {
        backgroundColor: "#f76c5e !important",
        borderLeft: "4px solid #d00000 !important",
        "&:hover": {
            backgroundColor: "#a44a3f !important",
        },
    },
    "& .MuiDataGrid-columnHeader": {
        backgroundColor: "#0a2240",
        color: "#fff !important",
    },
    "& .MuiDataGrid-sortIcon, .MuiDataGrid-filterIcon": {
        color: "#0a2240 !important",
    },
    ".MuiDataGrid-root .MuiDataGrid-columnHeader .MuiDataGrid-sortButton": {
        backgroundColor: "#d00000",
    },
    "& .MuiDataGrid-columnHeader:hover": {
        color: "#fff !important",
    },
    "& .MuiDataGrid-headerFilterRow .MuiInputBase-root": {
        backgroundColor: "white !important",
    },
    "& .MuiDataGrid-menuIcon .MuiDataGrid-menuIcon:hover": {
        color: "#fff !important",
    },
    "& .MuiDataGrid-columnHeader.MuiDataGrid-columnHeader--filter.MuiDataGrid-withBorderColor":
    {
        backgroundColor: "white !important",
    },
    "& .highlight-row": {
        backgroundColor: "#e3f2fd !important",
        "&:hover": {
            backgroundColor: "#bbdefb !important",
        },
    },
    "& .MuiDataGrid-filterIcon": {
        color: "#0a2240 !important"
    },
    "& .MuiDataGrid-toolbarContainer .MuiButtonBase-root": {
        color: "#005AA6",
    },
    '& .MuiDataGrid-pinnedRows--bottom .MuiDataGrid-row.total-row': {
        backgroundColor: '#FFE9B3 !important',
        fontWeight: "700 !important",
    },
    "& .MuiDataGrid-menuIconButton":{
        color: "#fff"
    }
}));

const XranDataGrid = ({
    columns = [],
    rows = [],
    filteredRows = [],
    density,
    datagridName,
    loading,
    setRows,
    customAction,
    actionFilters,
    showExport = true,
    editMode = 'cell'
}) => {
    LicenseInfo.setLicenseKey(

        "7b2a7be60c5eff8e15f1f2ae43e1260dTz0xMjMyNTksRT0xNzk3NDY1NTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y"

    );


    const apiRef = useGridApiRef();
    const [filterModel, setFilterModel] = useState({
        items: [],
    });

    // logic for stiped datagrid

    // const getRowClassName = (params) => {
    //     if (params.row.Msgtype === "E") {
    //         return "highlighted-row";
    //     }
    //     if (params.row.isTotalRow) {
    //         return 'total-row';
    //     }

    //     return params.indexRelativeToCurrentPage % 2 === 0 ? 'odd' : 'even';
    // };

    const getRowClassName = (params) => {
        if (params.row.Msgtype === "E") {
            return "highlighted-row";
        }
        if (params.row.isTotalRow) {
            return 'total-row';
        }
        return '';
    };

    const handleProcessRowUpdate = (newRow, oldRow) => {
        const updatedRows = rows.map((row) =>
            row.id === newRow.id ? newRow : row
        );
        setRows(updatedRows);
        return newRow;
    };

    function CustomToolbar() {
        return (
            <GridToolbarContainer sx={{ padding: "0.8rem" }}>
                {/* Left Side - Heading */}
                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: 700,
                        fontSize: "20px",
                        color: '#0a2240',
                        letterSpacing: '-0.5px',
                        mr: 2
                    }}
                >
                    JMA XRAN Global Systems
                </Typography>

                {actionFilters}
                <div style={{ flexGrow: 1 }} />

                {/* Right Side - Three Buttons */}                
                <Button  variant="outlined"
                   
                >
                    <Typography sx={{ fontWeight: 500, fontSize: "0.8125rem" }}>
                        SRO2.10 UPGRADE STATUS
                    </Typography>
                </Button>
                <Button  variant="outlined"
                    startIcon={<AddIcon sx={{ fontWeight: 500, fontSize: "0.8125rem" }} />}
                >
                    <Typography sx={{ fontWeight: 500, fontSize: "0.8125rem" }}>
                        NEW SYSTEM
                    </Typography>
                </Button>
                <GridToolbarExport
                    csvOptions={{ disableToolbarButton: true }}
                    printOptions={{ disableToolbarButton: true }}
                    excelOptions={{
                        fileName: "data-export",
                        allColumns: true,
                        columnsStyles: {
                            Message: { hidden: false },
                        },
                    }}
                    slotProps={{
                        tooltip: { title: "Download Excel" },
                        button: { variant: "outlined", style: { marginRight: "0.5rem" } },
                    }}
                />
            </GridToolbarContainer>
        );
    }

    return (
        <StyledDataGridPremium
            hideFooter
            rows={filteredRows}
            columns={columns}
            density={density}
            getRowId={(row) => row.id}
            apiRef={apiRef}
            loading={loading}
            filterMode="client"
            headerFilters={true}
            filterModel={filterModel}
            onFilterModelChange={(newFilterModel) => setFilterModel(newFilterModel)}
            getRowClassName={getRowClassName}
            editMode={editMode}
            processRowUpdate={handleProcessRowUpdate}
            slotProps={{
                headerFilterCell: {
                    sx: {
                        backgroundColor: 'white',
                    }
                }
            }}
            slots={{
                toolbar: CustomToolbar,
            }}
            showToolbar
            sx={{
                height: '85vh',
                width: '100%',
                border: 'none',
                borderRadius: 1,
                backgroundColor: '#fff',
                mx: 'auto',
                "& .css-ckj3ov-MuiDataGrid-toolbarLabel": {
                    fontWeight: "700",
                    fontSize: "20px"
                },
                "& .css-53g0n7-MuiButtonBase-root-MuiIconButton-root": {
                    color: "#005AA6"
                },
                "& .css-1gxrdpv-MuiButtonBase-root-MuiIconButton-root-MuiDataGrid-toolbarQuickFilterTrigger": {
                    color: "#005AA6"
                },
                '& .system-name-cell': {
                    backgroundColor: 'rgb(191, 219, 254)',
                }
            }}
        />
    );
};

export default XranDataGrid;
